var $2c38dbfaf041a865$exports = {};
$2c38dbfaf041a865$exports = {
    "close": `\u{B2EB}\u{AE30}`,
    "notifications": `\u{C54C}\u{B9BC}`
};


export {$2c38dbfaf041a865$exports as default};
//# sourceMappingURL=ko-KR.module.js.map
